// extracted by mini-css-extract-plugin
export default {"InfoButton":"InfoButton_InfoButton__OsbTL","InfoButton__Icon":"InfoButton_InfoButton__Icon__2DFrl","InfoButton__Cross":"InfoButton_InfoButton__Cross__7nezW"};